import { Color } from './color';
import { BaseEntity } from './base-entity';

export interface Colorset extends BaseEntity {
  name: string;
  //colors: Array<Color>;
  colors: string[];
}

export interface ColorsetTemplate {
  name: string;
  colors: string[];
}

export type ColorSchemeType =
  | 'complementary'
  | 'analogous'
  | 'triadic'
  | 'tetradic';

export const colorsetSchemes: { name: string; key: ColorSchemeType }[] = [
  {
    name: 'Komplementär',
    key: 'complementary',
  },
  {
    name: 'Analog',
    key: 'analogous',
  },
  {
    name: 'Triadisch',
    key: 'triadic',
  },
  {
    name: 'Tetradisch',
    key: 'tetradic',
  },
];

export const fallbackColors: string[] = [
  //'#246090',
  //'#2B77B3',
  //'#388DD0',
  //'#5AA1D9',
  //'#7CB5E2',
  //'#9EC8EA',
  '#1B9E77',
  '#D95F02',
  '#7570B3',
  '#E7298A',
  '#66A61E',
  '#E6AB02',
  '#A6761D',
  '#666666',
];

export const fallbackColorset: Colorset = {
  _id: '0',
  name: 'Standard',
  colors: fallbackColors,
};

export const colorsetTemplates: ColorsetTemplate[] = [
  {
    name: 'Farbset monochrom',
    colors: fallbackColors,
  },
  {
    name: 'Farbset komplementär',
    colors: ['#72bb63', '#5aa1d9', '#003f80', '#f3910d'],
  },
  {
    name: 'Farbset triadisch',
    colors: ['#807318', '#FFE10A', '#10A3B3', '#135E66', '#BF247A'],
  },
  {
    name: 'Farbset analog (grün – blau)',
    colors: ['#00C74B', '#0FD19E', '#00A8B8', '#027CD1', '#083AC7'],
  },
  {
    name: 'Farbset analog (rot – grün) ',
    colors: ['#D73027', '#FC8D59', '#FEE08B', '#D9EF8B', '#91CF60', '#1A9850'],
  },
];

export const templateByIndex = function (index: number) {
  return colorsetTemplates[index];
};
